export const ADMIN_ROUTES = {
  ROOT: '/admin',
  DASHBOARD: '/admin/dashboard',
  ONBOARDING: '/admin/onboarding',
  /** @deprecated Redirects to ONBOARDING?stage=background_check */
  VERIFICATION_QUEUE: '/admin/verification-queue',
  /** @deprecated Redirects to ONBOARDING?stage=profile_review */
  REVIEW_QUEUE: '/admin/review-queue',
  TRAVELERS: '/admin/travelers',
  GUIDES: '/admin/guides',
  BOOKINGS: '/admin/bookings',
  BLOGS: '/admin/blogs',
  BLOGS_NEW: '/admin/blogs/new',
  LIVE_CITIES: '/admin/live-cities',
  FINANCE: '/admin/finance',
  GROWTH: '/admin/growth',
  SETTINGS: '/admin/settings',
  /** @deprecated use FINANCE?tab=withdrawals */
  FINANCE_WITHDRAWALS: '/admin/finance/withdrawals',
  /** @deprecated use FINANCE?tab=settlements */
  FINANCE_SETTLEMENTS: '/admin/finance/settlements',
  /** @deprecated use FINANCE?tab=disputes */
  DISPUTES: '/admin/disputes',
  onboarding: (stage?: string) =>
    stage ? `/admin/onboarding?stage=${stage}` : '/admin/onboarding',
  review: (profileId: string) => `/admin/guides/${profileId}/review`,
  identityCard: (profileId: string) => `/admin/guides/${profileId}/identity-card`,
  booking: (bookingId: string) => `/admin/bookings?id=${bookingId}`,
  blogEdit: (id: string) => `/admin/blogs/${id}/edit`,
} as const;
